import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { OrganizationService } from 'src/app/services/organization.service';
import { Lookup } from 'src/app/model/lookup';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { ZoneService } from 'src/app/services/zone.service';

@Component({
  selector: "app-zone-update-dialog",
  templateUrl: "./zone-update-dialog.component.html",
  styleUrls: ["./zone-update-dialog.component.scss"]
})
export class ZoneUpdateDialogComponent implements OnInit {
  public form: any;
  public roleList: Lookup[] = [];
  public adminRole: any;
  public orgId: number;
  public organizationList: Lookup[] = [];
  public isStatus: boolean = true;
  ptype: any;
  mticket: any;

  constructor(public dialogRef: MatDialogRef<ZoneUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public organizationService: OrganizationService,
    public zoneService: ZoneService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public authenticationService: AuthenticationService,
    public lookupService: LookupService) {}

  ngOnInit() {
    this.adminRole = this.authenticationService.currentUserValue.role;
    this.orgId = this.authenticationService.currentUserValue.organizationId;
    if(this.data.parkingType == '2'){
      this.data.description = 'Permitted';
    }

    this.ptype = (this.data.parkingType).toString();
    this.mticket = (this.data.multipleTicket).toString();

    // if(this.data.status == 1){
    //   this.isStatus = true;
    // }
    // else{
    //   this.isStatus = false;
    // }

    this.initlizeUserUpdateForm();
    this.setValues();
    this.showhideField();
  }

  showField(){
    document.getElementById('hiddenField').className = "d-block";
  }

  hideField(){
    document.getElementById('hiddenField').className = "d-none";
  }

  showhideField(){
    let fielddata = this.form.getRawValue();
    if(fielddata.parkingType == "1"){
      this.showField();
    }
    if(fielddata.parkingType == "2"){
      this.hideField();
    }
  }

  setValues() {
    this.form.setValue({
      zoneId: this.data.zoneId,
      zoneName: this.data.zoneName,
      parkingType: this.ptype,
      description: this.data.description,
      duration: this.data.duration,
      gracePeriod: this.data.gracePeriod,
      multipleTicket: this.mticket,
      // status: this.isStatus
    });
  }

  initlizeUserUpdateForm(): void {
    this.form = new FormGroup({
      zoneId: new FormControl("", Validators.required),
      zoneName: new FormControl("", Validators.required),
      parkingType: new FormControl(this.ptype, Validators.required),
      description: new FormControl("Flowbird", Validators.required),
      duration: new FormControl("", Validators.required),
      gracePeriod: new FormControl("", Validators.required),
      multipleTicket: new FormControl(this.mticket, Validators.required),
      // status: new FormControl(this.isStatus, Validators.required)
    });
  }

  updateZoneData(): void {
    let data = this.form.getRawValue();
    data.organizationId = this.orgId;
    //data.organizationId = this.tokenStorage.getOrganizationId();
    //data.status = this.isStatus ? 1 : 3;

    this.zoneService.updateZone(data)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.toastrService.success(response.value, "Zone Updated Successfully!");
        this.dialogRef.close(true);
      } else {
        this.toastrService.error(response.value, "Failed To Load Data!")
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}